export default {
  title: 'צפייה בהסכמים של הסוכן {1}',
  noHistoryData: 'אין נתונים להצגה',
  labels: {
    agentnumber: 'מספר סוכן',
    save: 'עדכון',
    cancel: 'ביטול',
    delete: 'מחיקה',
    date: {
      depositFrom: 'החל מתאריך לעמלות נפרעים',
      accumulationFrom: 'החל מתאריך לעמלות היקף',
      depositUntil: 'תוקף לעמלות נפרעים',
      accumulationUntil: 'תוקף לעמלות היקף',
      start: 'החל מתאריך',
      end: 'עד תאריך',
    },
    errors: {
      update: 'הפרטים לא עודכנו',
      delete: 'ההסכם לא נמחק',
    },
    success: {
      update: 'הפרטים עודכנו בהצלחה',
      delete: 'עמלת הסוכן הועברה לארכיון בהצלחה',
    },
    branch: 'מוצרים',
    accordType: 'סוג הסכם',
    accordName: 'שם הסכם',
    comments: 'הערות',
    edit: 'ערוך הסכם',
    add: 'הוסף הסכם',
    history: 'היסטוריית הסכמים',
    commission: {
      agentFeeMonthlyDeposit: 'עמלת סוכן נפרעים מהפקדה %',
      agentFeeMonthlyAccumulation: 'עמלת סוכן נפרעים מצבירה %',
      agentFeeAnnualAccumulation: 'עמלת סוכן היקף מצבירה %',
      agentFeeAnnualDeposit: 'עמלת סוכן היקף מהפקדה %',
      employeeAgentCommission: 'עמלת סוכן שכיר %',
      agentFee: 'עמלת סוכן',
      noData: 'אין מידע',
    },
  },
};
